var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.846,13.962a8.556,8.556,0,0,0-2.608-6.276,8.559,8.559,0,0,0-6.276-2.609A8.555,8.555,0,0,0,7.684,7.684a8.555,8.555,0,0,0-2.608,6.277,8.561,8.561,0,0,0,2.608,6.276,8.555,8.555,0,0,0,6.277,2.608,8.552,8.552,0,0,0,6.276-2.608A8.566,8.566,0,0,0,22.846,13.962ZM33,30.462A2.573,2.573,0,0,1,30.462,33a2.357,2.357,0,0,1-1.785-.753l-6.8-6.782a13.58,13.58,0,0,1-7.913,2.459,13.714,13.714,0,0,1-5.424-1.1A13.669,13.669,0,0,1,1.1,19.386a13.912,13.912,0,0,1,0-10.848A13.669,13.669,0,0,1,8.538,1.1a13.912,13.912,0,0,1,10.848,0,13.669,13.669,0,0,1,7.437,7.437,13.7,13.7,0,0,1,1.1,5.424,13.577,13.577,0,0,1-2.459,7.913l6.8,6.8A2.429,2.429,0,0,1,33,30.462Z",
    transform: "translate(0.5 0.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e18dc875eaa85c1745f6f539cf6988cc.svg";
export { ForwardRef as ReactComponent };